/**
 * Product list "Best sellers". Shopify sorts products by sales only on a collection URL, so the section is rendered
 * again through the Section Rendering API on the all-products collection with ?sort_by=best-selling, and its product
 * lists replace the server-rendered fallback beside this hidden marker. The fallback stays when the request fails or
 * finds no products.
 */
class FragranceBestSellers extends HTMLElement {
  connectedCallback() {
    if (this.dataset.url) this.#load();
  }

  async #load() {
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const marker = html.querySelector(`fragrance-best-sellers[data-section-id="${this.dataset.sectionId}"]`);
      const lists = marker ? this.#lists(marker) : [];
      if (!lists.some((list) => list.querySelector('.resource-list__item'))) return;

      this.#lists(this).forEach((list) => list.remove());
      this.after(...lists.map((list) => document.adoptNode(list)));
    } catch {
      // Keep the fallback list.
    }
  }

  /** Horizon renders the product list as sibling grids (desktop grid, mobile carousel) after this marker. */
  #lists(marker) {
    return [...marker.parentElement.children].filter((element) => element.classList.contains('resource-list'));
  }
}

if (!customElements.get('fragrance-best-sellers')) customElements.define('fragrance-best-sellers', FragranceBestSellers);
